/*
 * OtpPage.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Feb 02 2023 mys Company
 */

import { useLogin } from '../hook/useAccountHooks'
import bg01 from '../../../assets/images/Rectangle.png'
import logoPNG from '../../../assets/images/bg-01.jpg'
import { localization } from '../../../config/localize/localizable'
import DoneButton from '../../../component/element/DoneButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FormikTextField from '../../../component/element/FormikTextField'
import * as constants from '../../../config/constant/constants'
import { useLocation, useNavigate } from 'react-router-dom'

const OtpPage = () => {
    //
    //  MARK: VARIIABLE

    const Login = useLogin()
    const navigate = useNavigate()
    const location = useLocation()

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(localization.MSG_code_isrequired).min(5, localization.MSG_mincharacter).max(6, localization.MSG_maxcharacter),
    })

    const formik = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema,
        // validateOnChange: false,
        validateOnBlur: true,
        onSubmit: (values) => {
            handleClick(values)
        },
    })

    //
    //  MARK: METHOD
    const handleClick = async (model) => {
        navigate('/adminpanel/dashboard', { replace: true })
        // await Login.loginService(
        //   {
        //     username: model.userName,
        //     password: model.password,
        //     type: "EMAIL",
        //     moduleType: "WEB",
        //   },
        //   {
        //     onSuccess: async (result) => {
        //       constants.setUserId(result.data.userId);
        //       constants.setToken(result.data.token);
        //       constants.setServerDate(result.data.date);
        //       constants.setIsExpert(result.data.expert);
        //       constants.setMenus(JSON.stringify(result.data.menus));
        //       navigate("/adminpanel/dashboard", { replace: true });
        //     },
        //   }
        // );
    }

    return (
        <div
            className="w-full h-screen bg-no-repeat bg-cover bg-fixed fixed mb-4 select-none"
            style={{
                backgroundImage: 'url(' + bg01 + ')',
            }}
        >
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 h-screen">
                <div className="col-span-1 bg-white">
                    <img src={logoPNG} className="h-20 m-auto my-32 rounded shadow-sm" alt="logo" />
                    <form className=" m-8 my-32 rounded">
                        {/* <h1 className="text-center font-bold text-lg mb-3x ">{localization.adminpanel + " " + localization.productname}</h1> */}
                        <h6 className=" text-sm">
                            {`برای ادامه مسیر کد یکبار مصرف ارسال شده به شماره `} <span className="text-green-400">{location.state?.mobilenumber ?? '09123964349'}</span> {` را وارد کنید`}
                        </h6>

                        <div className="form-group mb-3 mt-4">
                            <FormikTextField name="code" formik={formik} caption={localization.otpcode} placeHolder={localization.otpcode} inputMode="numeric" />
                        </div>

                        <div className="form-group mb-3 mt-7">
                            <DoneButton type="button" caption={localization.ok} onClick={formik.handleSubmit} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default OtpPage
